import { HTMLAttributes } from 'react'
import * as Styles from './styles'

type Props = HTMLAttributes<HTMLDivElement> & {
  isCompleted?: boolean
  text: {
    badge?: string
    header: string
    subHeader: string
    actionText?: string
  }
  src?: string
  bannerType?: 'image' | 'text'
  children?: React.ReactNode | React.ReactNode[]
  handleClick?: () => void
  actionButtonTestId?: string
}
export const InfoBox = ({
  isCompleted,
  text,
  children,
  handleClick,
  actionButtonTestId,
  ...props
}: Props) => {
  return (
    <Styles.Container {...props}>
      <Styles.Badge visible={!isCompleted}>
        <Styles.BadgeText>{text.badge || 'Badge'}</Styles.BadgeText>
      </Styles.Badge>

      <Styles.TextContainer>
        <Styles.Header>{text.header}</Styles.Header>
        <Styles.SubHeader>{text.subHeader}</Styles.SubHeader>
      </Styles.TextContainer>
      <Styles.ActionContainer>
        {children || (
          <Styles.ButtonContainer onClick={handleClick} data-testid={actionButtonTestId}>
            <Styles.ActionText>{text.actionText}</Styles.ActionText>
            <Styles.IconContainer>
              <Styles.Icon />
            </Styles.IconContainer>
          </Styles.ButtonContainer>
        )}
      </Styles.ActionContainer>
    </Styles.Container>
  )
}
